/** sessionStorage: full return path+search when leaving /agendamento auth for site login/register */
export const PLUMAA_SCHEDULING_RETURN_URL_KEY = 'PLUMAA_SCHEDULING_RETURN_URL';
